import * as c from '../constants';

const onGetPage = (data, sports) => ({
    type: c.GET_PAGE,
    data,
    sports
})

export const getPage = (slug) => {
    return (dispatch, getState, { api }) => {
        api.get(`content/slug/${slug}`, {}, dispatch)
            .then(response => {
                if(!response) return false;
                const { data, sports, success } = response;

                if(success) {
                    return dispatch(onGetPage(data, sports));
                }
                dispatch(onGetPage({},[]));
            })
    }
}


// WEBPACK FOOTER //
// ./src/pages/actions/index.js